module.exports = __webpack_public_path__ + "img/w3_user_dark.602f4ac1.png";